export default __webpack_public_path__ + "static/media/redshadowsofxotli.d813e862.png";